export default "__VITE_ASSET__BW4ogNaF__"